module.exports = __webpack_public_path__ + "img/map.1092b362.png";